import { Dialog } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import Api from "../../common/Api";
import ApiUrl from "../../common/ApiUrl";
import { segmentEvents } from "../../utils/constants";
import SolidButton from "../common/SolidButton";
import "./layout.css";

const BatchPopup = ({ open, handleClose, courses, studentData }) => {
	const [courseID, setCourseID] = React.useState(0);
	const currentIndex = React.useRef(0);
	const history = useHistory();

	React.useEffect(() => {
		currentIndex.current = courses.findIndex((c) => c.is_enable);
		if (courses.length > 0) setCourseID(currentIndex.current);
	}, [courses]);

	const switchCourse = () => {
		
			const formdata = new FormData();
			formdata.append("student_id", studentData.id);
			formdata.append("student_course_id", courseID);
			Api.doUpload("POST", formdata, ApiUrl.SWITCH_COURSE)
				.then((response) => {
					if (response.status === true) {
						history.push({
							pathname: "/student",
						});
						document.location.reload();
					} else {
						alert(response.message);
					}
				})
				.catch(() => {
					this.props.history.push("/error");
				});
		
	};

	return (
		<>
			<Dialog
				open={open}
				onClose={handleClose}
				PaperProps={{
					style: { width: "100%" },
				}}>
				<div className="popup-container-batch">
					<div className="headerFlex">
						<div className="popupHeading">Switch Batch</div>
					</div>

					<div className="batchList">
						{courses
						.filter(item => !item.section_name.includes('JCF_') && !item.section_name.includes('M.A.T_'))
						.map((item, i) => {
							return (
								<div
									onClick={() => setCourseID(item.student_course_id)}
									className={`batchName ${item.student_course_id === courseID ? "selectedBatch" : ""}`}
									key={i}>
									{item.section_name}
								</div>
							);
						})}
					</div>

					<div className="buttonContainerPopup">
						<SolidButton 
							small 
							style={{ width: 90 }} 
							onClick={() => {
								Api.trackEvent(segmentEvents.SWITCHBATCH.DONE_CLICK);
								switchCourse();
							}}
						>
							Done
						</SolidButton>
					</div>
				</div>
			</Dialog>
		</>
	);
};

export default BatchPopup;
